"use client";
import { useRouter } from "next/navigation";
import { isEmpty, isString, isObject, some, includes } from "utils/lodash";
import routeStore from "utils/routeStore";
// const pathList = ["/shop", "/search"];
const useRoute = () => {
  const nextRouter = useRouter();
  const router = {
    ...nextRouter,
    push: (pathname: any, params?: { [key: string]: any }) => {
      if (!isEmpty(params)) {
        nextRouter.push(pathname);

        let _params = params;
        routeStore.resetRedirect();
        if (!isEmpty(params.redirect)) {
          const { redirect, ...rest } = params;
          if (isString(redirect)) {
            routeStore.setRedirect({ pathname: redirect });
          } else if (isObject(redirect)) {
            routeStore.setRedirect(redirect);
          }
          _params = rest;
        }
        routeStore.setParams(_params);
      }
      nextRouter.push(pathname);
    },
    handleDeepLink: (url: string) => {
      const isDubLink = url.includes("s.lookme.vn");
      if (isDubLink) {
        window.open(url, "_blank");
      } else {
        // const isPathMatch = some(pathList, (path) => {
        //   return includes(url, path);
        // });
        // if (isPathMatch) {
        nextRouter.push(url);
        // }
      }
    },
  };
  return router;
};
export default useRoute;
